// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"67c1fe9a","88":"3adf3880","159":"5067f775","320":"6734e6f0","486":"91f8bb6c","565":"0bc2ce50","707":"e0ce02eb"}[chunkId] + ".chunk.js";
};